import {StickyHeaderContentArea} from '@defign/ui'

import InsuranceFlexibleLayout from '$components/insurance/common/InsuranceFlexibleLayout'
import InsuranceDetailFreeSection from '$components/insurance/my/detail/free/InsuranceDetailFreeSection'
import InsuranceDetailFreeTitle from '$components/insurance/my/detail/free/InsuranceDetailFreeTitle'
import InsuranceMyHeader from '$components/insurance/my/InsuranceMyHeader'
import {INTERNAL_ROUTES} from '$constants/internal-routes'
import InsurancePageProvider from '$contexts/insurance/common'
import {withNonAuthInsuranceGetServerSideProps} from '$hoc/insurance'
import useFreeInsuranceDetail from '$hooks/insurance/my/free/useFreeInsuranceDetail'
import {getFreeInsuranceDetailQuery, getRegionsQuery} from '$queries/insurance/myQuery'
import {getDehydratedState, prefetchQueries} from '$server/utils/query'

import type {InsurancePageProps} from '$contexts/insurance/common'
import type {GetServerSideProps} from 'next'

function FreeHeader() {
    const {name} = useFreeInsuranceDetail()

    return <InsuranceMyHeader title={name} hideManagementButton backNClickCode="insudetail.back" />
}
export default function MyInsuranceFree(props: InsurancePageProps) {
    return (
        <InsurancePageProvider {...props}>
            <StickyHeaderContentArea hideHeaderOnScroll={false} isFixedHeader header={<FreeHeader />}>
                <InsuranceDetailFreeTitle />
                <StickyHeaderContentArea.Fixed>
                    {/** 탭은 없지만 타이틀 영역 지나서 스크롤 시 InsuranceMyHeader에 title을 노출하기 위해 Fragment 설정 */}
                    <></>
                </StickyHeaderContentArea.Fixed>
                <InsuranceFlexibleLayout>
                    <InsuranceDetailFreeSection />
                </InsuranceFlexibleLayout>
            </StickyHeaderContentArea>
        </InsurancePageProvider>
    )
}

export const getServerSideProps: GetServerSideProps = withNonAuthInsuranceGetServerSideProps(
    async (ctx, queryClient) => {
        const {
            query: {id: rCode, insuranceId: id},
        } = ctx

        if (
            typeof rCode !== 'string' ||
            Number.isNaN(Number(rCode)) ||
            typeof id !== 'string' ||
            Number.isNaN(Number(id))
        ) {
            return {
                redirect: {
                    destination: INTERNAL_ROUTES.INSURANCE_MY_HOME,
                    permanent: false,
                },
            }
        }

        const assetId = +id

        if (typeof assetId !== 'number' || Number.isNaN(assetId)) {
            return {
                redirect: {
                    destination: INTERNAL_ROUTES.INSURANCE_MY_HOME,
                    permanent: false,
                },
            }
        }

        const regionsQuery = getRegionsQuery.serverQuery({req: ctx.req})
        const freeInsuranceDetailQuery = getFreeInsuranceDetailQuery.serverQuery({params: {assetId}, req: ctx.req})

        await prefetchQueries([regionsQuery, freeInsuranceDetailQuery], queryClient)

        return {
            props: {
                dehydratedState: getDehydratedState(queryClient),
            },
        }
    },
)
